import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import{AppRoutingModule } from './app.routing';
import { GetItemService } from './get-item.service';
import { CookieService } from 'ngx-cookie-service';
import { GlobleApiService,UpcomingTestService } from "./application/services";
import { environment } from "../environments/environment";
import { sideMenuIcon } from "../app/application/model";

@Component({
   // tslint:disable-next-line
   selector: 'body',
   templateUrl: './app.component.html',
   styleUrls: ['./app.component.css'],
   providers: [GetItemService]
})
export class AppComponent implements OnInit {
  roleName: any;
  userDetails: any;
  org_image: any;
  currentOrgName: any;
  showSideBar: boolean;
  loaders: Boolean = false;
  isShow: boolean = true;
   sideMenu: sideMenuIcon;
  showAllOrgs: boolean = false;
  userOrgId: any;
  checkPassword: boolean;
  TotalItemCount:any = '0';
  TotalTestCount: any ='0';
   isOpen: boolean;
  pendingInvitesList: any[]=[];
    private keydownHandler: any;
  private clickHandler: any;
  constructor(private router: Router, private cookieService: CookieService,private API:GlobleApiService , private TESTAPI : UpcomingTestService) {
      this.sideMenu = new sideMenuIcon()
    }
  ngOnInit(): void {
    this.roleName = this.cookieService.get('_PAORN');
    this.GetUserDetails()

   

    let s_menu = this.cookieService.get('s_menu');
    if (s_menu) {
      this.selectcolor(s_menu)
    }else{
        this.selectcolor('home')
    }

       // ✅ Bind handlers
    this.keydownHandler = () => this.resetActivity();
    this.clickHandler   = () => this.resetActivity();
        // ✅ Add event listeners
    window.addEventListener('keydown', this.keydownHandler);
    window.addEventListener('click', this.clickHandler);

   
  }
   
  GetUserDetails() {
    this.loaders = true;
    this.showSideBar = false;
    this.API.userDetailes().subscribe((doc:any) =>{
      console.log(doc,"------->.>>.>..>",doc.user_login_details.profile_email);
      this.userDetails = doc.user_login_details;
      this.showSideBar = true;
      this.cookieService.set('login_email',doc.user_login_details.profile_email,100000, '/', environment.uiHost, false);
      // this.org_image = this.userDetails.available_organization[0].organization_img
      // this.cookieService.set('login_email',doc.user_login_details.profile_email)
      this.cookieService.set('profile_name', this.userDetails.profile_name, 100000, '/', environment.uiHost, false);
      this.cookieService.set('org_image',this.userDetails.available_organization[0].organization_img,100000, '/', environment.uiHost, false)
      this.cookieService.set('profile_picture', this.userDetails.profile_picture,100000, '/', environment.uiHost, false)
      this.cookieService.set('profile_id',this.userDetails.profile_id,100000, '/', environment.uiHost, false)
      let orgid = this.cookieService.get('_PAOID');
      console.log(orgid,"%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%")
      const org_def_id = this.cookieService.get('N_POID')
        if (org_def_id) {
            const orgData = this.userDetails.available_organization.find((e:any) => e.org_id == org_def_id)
            if (!this.cookieService.get('_PAORN')) {
               this.cookieService.set('_PAORN', orgData.organization_roles[0]);
               this.roleName = orgData.organization_roles[0]
            }else{
              this.roleName = this.cookieService.get('_PAORN')
            }
            this.cookieService.set('_PAOID', orgData.org_id, 100000, '/', environment.uiHost, false);
            // this.cookieService.set('_PAOID', orgData.org_id);
              this.currentOrgName = orgData.organization_name;
            this.org_image = orgData.organization_img
          
          //  this.userDetails.available_organization[0].organization_roles = orgData.organization_roles.filter((e:any) => e == 'Participant')
          this.userOrgId = org_def_id;
            // this.selectcolor('upcoming_test')
            // this.router.navigate(['/scora-participant/upcoming-test'])
             console.log(this.roleName,"^^^^^^^^^^^^^^^^^^^^^^^1")
          this.reorderOrganizations(this.userOrgId , this.roleName)
        }else{
          if (!orgid) {
                // this.cookieService.set('_PAORN', this.userDetails.available_organization[0].organization_roles[0]);
                this.cookieService.set('_PAOID', this.userDetails.available_organization[0].org_id, 100000, '/', environment.uiHost, false);
                // this.cookieService.set('_PAOID', this.userDetails.available_organization[0].org_id);
                this.currentOrgName = this.userDetails.available_organization[0].organization_name;

              // this.userDetails.available_organization[0].organization_roles = this.userDetails.available_organization[0].organization_roles.filter((e:any) => e == 'Participant')
             this.userOrgId = this.userDetails.available_organization[0].org_id;
             this.org_image = this.userDetails.available_organization[0].organization_img
              let roleNames = this.userDetails.available_organization[0].organization_roles.filter((e:any) => e == 'Participant')
            if (!this.cookieService.get('_PAORN')) {
               this.cookieService.set('_PAORN', roleNames);
               this.roleName = roleNames
            }else{
              this.roleName = this.cookieService.get('_PAORN')
            }
            console.log(this.roleName,"^^^^^^^^^^^^^^^^^^^^^^^2")
          this.reorderOrganizations(this.userOrgId , this.roleName)
          }else{
             this.userOrgId = orgid;
               const orgData = this.userDetails.available_organization.find((e:any) => e.org_id == orgid)
                // this.cookieService.set('_PAORN', orgData.organization_roles[0]);
                this.cookieService.set('_PAOID', orgData.org_id, 100000, '/', environment.uiHost, false);
                this.cookieService.set('_PAOID', orgData.org_id);
                this.currentOrgName = orgData.organization_name;
                 this.org_image = orgData.organization_img

              let roleNames = orgData.organization_roles.filter((e:any) => e == 'Participant')
            
              if (!this.cookieService.get('_PAORN')) {
               this.cookieService.set('_PAORN', roleNames);
               this.roleName = roleNames
                }else{
                  this.roleName = this.cookieService.get('_PAORN')
                }
                console.log(this.roleName,"^^^^^^^^^^^^^^^^^^^^^^^3")
              this.reorderOrganizations(this.userOrgId , this.roleName)
          }
          
       }


         this.cookieService.set('org_image',this.org_image,100000, '/', environment.uiHost, false)
      // this.cookieService.set('_PAOID', this.userDetails.available_organization[0].org_id, 100000, '/', environment.uiHost, false);
        localStorage.setItem('_CVFT',this.userDetails.tenant_admin) ;
          this.TESTAPI.initUpcomingTests();

          this.TESTAPI.upcomingTests$.subscribe(data => {
          console.log(data,"NewData -------------------->")
          this.TotalItemCount = data.scheduled_tests == undefined ? '0' : String(data.scheduled_tests.length)
          });
       this.getTestCount()
      this.loaders = false;
    })
  }

    isActive(urls: string[]): boolean {
    return urls.some(url => this.router.isActive(url, false));
  }


  // getTestCount(){
  //   this.API.$getCountTest().subscribe((doc:any) =>{
  //     let num = Number(doc.upcomingTest);
  //     let testHistory = Number(doc.testHistory);
  //     this.TotalItemCount = !isNaN(num) ? String(doc.upcomingTest) : '0'
  //     this.TotalTestCount = !isNaN(testHistory) ? String(doc.testHistory) : '0'
  //   })
  // }

  getTestCount() {
  this.API.$getCountTest().subscribe((doc: any) => {
    this.setCount(doc);
    //   this.API.$getCountTest().subscribe((doc: any) => {
    //   this.setCount(doc);
    // });
  });


}

setCount(doc: any) {
  let testHistory = Number(doc.testHistory);

  this.TotalTestCount = !isNaN(testHistory) ? String(doc.testHistory) : '0';
}


  // nextOrganisation(org_id, data ,role) {
  //   this.cookieService.set('_PAOID', org_id, 100000, '/', environment.uiHost, false);
  //   this.userOrgId = org_id;
  //   this.currentOrgName = data.organization_name;
  //   this.org_image = data.organization_img
  //   this.roleName = role
  //   this.cookieService.set('_PAORN', role, 100000, '/', environment.uiHost, false);
  //   this.router.navigate(['/scora-participant/home'])
  // }

  nextOrganisation(orgId,roleName,data) {

    console.log(orgId,roleName,data,"^^^^^^^^^^^^^^^^^^^^^^^")
       this.cookieService.set('_PAOID', orgId, 100000, '/', environment.uiHost, false);
       this.cookieService.set('N_POID', orgId, 100000, '/', environment.uiHost, false);
      // this.cookieService.set('organization_theme',JSON.stringify(org.organization_theme), 100000, '/', environment.uiHost, false)
      // this.cookieService.set('_PAOID', this.userDetails.available_organization[0].org_id);
      // this.cookieService.set('_PAOID', orgId, 100000, '/', credentials.authorUrl, false);
      if (roleName != 'Participant') {
        this.cookieService.set('_PAORN', roleName, 100000, '/', environment.uiHost, false);
      }


    this.userOrgId = orgId;
    this.roleName = roleName;
    this.cookieService.set('org_name',this.currentOrgName , 100000, '/', environment.uiHost, false)
      if(roleName == 'Super Admin'){
        this.cookieService.set('_APPNAME', 'Admin/Author', 100000, '/', environment.uiHost, false);
        window.open(`${environment.authorUrl}#/scora-tenant/home`,"_self")
      }
      else if(roleName == 'Author')
      {
        this.cookieService.set('_APPNAME', 'Author', 100000, '/', environment.uiHost, false);
         window.open(`${environment.authorUrl}#/scora-author/home`,"_self")
      }
      else if(roleName == 'Test Admin')
      {
        this.cookieService.set('_APPNAME', 'Test Admin', 100000, '/', environment.uiHost, false);
        
         window.open(`${environment.authorUrl}#/scora-test-admin/home`,"_self")
      }
      else if(roleName == 'Participant')
      {
        //  this.cookieService.set('_PAOID', orgId, 100000, '/', environment.uiHost, false);
        this.userOrgId = orgId;
        this.currentOrgName = data.organization_name;
        this.org_image = data.organization_img
        this.roleName = roleName
        this.cookieService.set('_PAORN', roleName, 100000, '/', environment.uiHost, false);
        this.router.navigate(['/scora-participant/home'])
      }
      else if(roleName == 'Examiner')
      {
        this.cookieService.set('_APPNAME', 'Examiner', 100000, '/', environment.uiHost, false);
        
         window.open(`${environment.authorUrl}#/scora-examiner/home`,"_self")
      }
      this.isOpen = false
  }

  logout() {
    this.loaders = true;
    this.API.$logout().subscribe((doc:any) =>{
      if (doc.success == true) {
     
      }
    })
    this.loaders = false;
    localStorage.removeItem('dataSource');
    const allCookies = this.cookieService.getAll();
    const cookiesToKeep = ['_EMAIL_N'];
    Object.keys(allCookies).forEach(cookieName => {
      if (!cookiesToKeep.includes(cookieName)) {
        this.cookieService.delete(cookieName);
      }
    });
    setTimeout(() => {
      window.location.href = environment.accountUrl;
    }, 1000);

  }
  minMax(){
    this.isShow = !this.isShow;
    
  }

    public selectcolor(type: any) {

      console.log(type ,"*****************")
    this.sideMenu = new sideMenuIcon()
    this.sideMenu[type] = `${this.sideMenu.selectedIcon}${type}.svg`;


      if (type != "undefined") {
        this.cookieService.set('s_menu' , type, 100000, '/', environment.uiHost, false)
      }else{
        this.cookieService.delete('s_menu')   
      }

    // this.sideMenu = new sideMenuIcon()
    // this.sideMenu[type] = `${this.sideMenu.selectedIcon}${type}.svg`;
    // this.cookieService.set('s_menu' , type)
   
    localStorage.removeItem('filter_data')
    localStorage.removeItem('for_filter_item');


  if (type =='1') {
      $("#check-password").modal('show');
      this.checkPassword = !this.checkPassword;
      // this.isVisiblePassword = true;
    }
     console.log(this.sideMenu[type])
  }

  toggleOrganizations() {
  this.showAllOrgs = !this.showAllOrgs;
}

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }


reorderOrganizations(orgId: any, role: any) {
  const orgs = this.userDetails.available_organization;

  let matched: any[] = [];
  let others: any[] = [];

  orgs.forEach(university => {
    const hasRole = university.organization_roles.includes(role);
    if (university.org_id == orgId && hasRole) {
      const sortedRoles = university.organization_roles.filter(r => r !== role).sort((a, b) => a.localeCompare(b));
      university.organization_roles = [role, ...sortedRoles];
      matched.push(university);
    } else {
      others.push(university);
    }
  });

  others.sort((a, b) => a.organization_name.localeCompare(b.organization_name));

  // Final merge
  this.userDetails.available_organization = [...matched, ...others];
}



 changePassword(isLogout:boolean){
    if(isLogout){
      this.logout()
    }
  }

      showPendingStatus(orgId:any, roleName:any){
    const orgDetails = this.userDetails.available_organization.filter((org:any) => org.org_id === orgId);
    this.pendingInvitesList = orgDetails[0].getAccessibleRoles;
    if (orgDetails[0]) {
      // Find role
      const matchedRole = orgDetails[0].getAccessibleRoles.find((role:any) => role.User_Role_Nm === roleName);

      if (matchedRole && matchedRole.role_status === 0) {
        return true;
      }else{
        return false;
      }
    }else{
     return false
    }
  }

resetActivity() {
    let selectMenu = this.cookieService.get('s_menu');
    // console.log("Activity detected - resetting timer",selectMenu);
    if (selectMenu != null && selectMenu != 'undefined' && selectMenu != '') {
        this.selectcolor(selectMenu)
    }else{
      this.selectcolor('home')
    }
    // Your reset logic here
  }
 }



// WEBPACK FOOTER //
// ./src/app/app.component.ts